(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svador-home"] && !Shopify.designMode) return;
  try {
    
function initSvEditorial(root=document){
  root.querySelectorAll('.sv-editorial').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const track=section.querySelector('.sv-editorial__track');
    const controls=section.querySelector('.sv-editorial__controls');
    const buttons=controls.querySelectorAll('button');
    controls.hidden=false;
    const update=()=>{
      const index=Math.round(track.scrollLeft/track.clientWidth);
      buttons[0].disabled=index===0;
      buttons[1].disabled=index>=track.children.length-1;
    };
    controls.addEventListener('click',event=>{
      const button=event.target.closest('button');
      if(!button)return;
      const index=Math.round(track.scrollLeft/track.clientWidth);
      const next=Math.max(0,Math.min(track.children.length-1,index+Number(button.dataset.direction)));
      track.scrollTo({left:next*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
    track.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initSvEditorial();
document.addEventListener('shopify:section:load',event=>initSvEditorial(event.target));

function initSvBestSeller(root=document){
  root.querySelectorAll('.sv-bestseller-slot').forEach(slot=>{
    if(slot.dataset.started)return;
    slot.dataset.started='true';
    const load=async()=>{
      try{
        const url=new URL(slot.dataset.bestUrl,location.origin);
        const response=await fetch(url,{credentials:'same-origin'});
        if(!response.ok)return;
        const html=await response.text();
        const doc=new DOMParser().parseFromString(html,'text/html');
        const card=doc.querySelector('.sv-bestseller[data-best-product]');
        if(!card)return;
        slot.replaceChildren(card);
        slot.hidden=false;
      }catch{}
    };
    load();
  });
}
initSvBestSeller();
document.addEventListener('shopify:section:load',event=>initSvBestSeller(event.target));


  } catch(e) { console.error(e); }
})();
})();
